 const topLeft="top left";
 const topRight="top right";
 const bottomLeft="bottom left";
 const bottomRight="bottom right";

export const Directions = {
    topLeft,
    topRight,
    bottomLeft,
    bottomRight
}